// Campus photo for /colleges/clarkson-university: Public domain, by Ross P. Robinson, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ASnellHall(2009).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/clarkson-university/; credited under the photo.
const photo = {
    "slug": "clarkson-university",
    "alt": "Snell Hall, a columned stone building with Clarkson College carved over the entrance, at Clarkson University in Potsdam, New York",
    "src": "/colleges/clarkson-university/campus-1600.webp",
    "srcSmall": "/colleges/clarkson-university/campus-800.webp",
    "srcMid": "/colleges/clarkson-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/clarkson-university/og.jpg",
    "title": "SnellHall(2009)",
    "author": "Ross P. Robinson",
    "license": "Public domain",
    "licenseUrl": null,
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ASnellHall(2009).jpg",
    "read": "2026-10-01"
};

export default photo;
